// extracted by css-extract-rspack-plugin
export default {"root":"L3t8L","label":"jsN41"};